<template>
    <div class="countdown-container">
        <div class="countdown-text-container">
            <h3 class="sec">{{duration}}</h3>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      num: 360,
      duration: 60
    };
  },
  props:{
    counter: {
        type: Number,
        default: 60
    }
  },
  mounted() {
    this.startTimer();
  },
  watch:{
    counter(oldVal){
        this.duration = oldVal
        this.startTimer()
    }
  },
  methods: {
    startTimer() {
        this.duration = this.counter ? this.counter : 60;
        var container = document.querySelector('.countdown-container');
        var sec = document.querySelector('.sec');
        const interval = setInterval(() => {
            if (this.duration > 0) {
                this.duration--;
                if (sec) {
                    sec.textContent = this.duration;
                    if (container) { 
                        container.style.setProperty("--a",this.num+"deg")
                        container.style.background = `conic-gradient(#00a42c var(--a) ,#00a42c 0deg ,#585862d5 0deg,#585862d5 360deg)`
                        this.num = this.num - (this.num / this.duration);
                    }
                }
            } else {
                clearInterval(interval); // Stop the timer when duration reaches 0
            }
      }, 1000);
    }
  }
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: black;
}

@property --a {
    syntax: '<angle>';
    inherits: false;
    initial-value: 360deg;
}

.countdown-container {
    --a: 360deg;
    position: relative;
    width: 5em;
    height: 5em;
    border-radius: 50%;
    transition: --a 1s linear;
    background: conic-gradient(#00a42c var(--a), #00a42c 0deg, #585862d5 0deg, #585862d5 360deg);
    animation: animations 2s linear 1 forward;
}

.countdown-container::before {
    position: absolute;
    content: "";
    width: 90%;
    height: 90%;
    background: rgb(255, 255, 255);
    border-radius: 50%;
    left: 50%;
    top: 50%;
    color: #fac7c78f;
    transform: translate(-50%, -50%);
}

.countdown-text-container {
    width: 70%;
    height: 100px;
    color: rgb(0, 0, 0);
    position: absolute;
    left: 50%;
    top: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.3em;
    font-size: 3em;
    transform: translate(-50%, -50%);

}

h3 {
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    font-weight: 500;
}
</style>
